import * as yup from "yup";
import { enums } from "../constants/enum";

const objectIdPattern = /^[0-9a-fA-F]{24}$/;
const objectIdSchema = yup
  .string()
  .trim()
  .matches(objectIdPattern, "Must be a valid ObjectId");

const paymentSchema = yup.object({
  amount: yup
    .number()
    .typeError("Payment amount must be a number.")
    .min(1, "Payment amount must be greater than or equal to 1.")
    .required("Payment amount is required."),
  type: yup
    .string()
    .oneOf(
      Object.values(enums.PAYMENT_TYPES),
      `Payment type must be one of ${Object.values(enums.PAYMENT_TYPES).join(
        ", ",
      )}.`,
    )
    .required("Payment type is required."),
  method: yup
    .string()
    .oneOf(
      Object.values(enums.PAYMENT_METHODS),
      `Payment method must be one of ${Object.values(
        enums.PAYMENT_METHODS,
      ).join(", ")}.`,
    )
    .required("Payment method is required."),
  date: yup
    .date()
    .default(() => new Date())
    .typeError("Payment date must be a valid date.")
    .required("Payment date is required."),
  chequeNumber: yup.string().when("method", {
    is: enums.PAYMENT_METHODS.CHEQUE,
    then: (schema) =>
      schema
        .required("Cheque number is required when payment method is CHEQUE.")
        .min(1, "Cheque number must have at least 1 character."),
    otherwise: (schema) => schema.notRequired().nullable(),
  }),
});

export const orderSchema = yup.object({
  orderForm: objectIdSchema.required("Order form ID is required."),
  orderDate: yup
    .date()
    .default(() => new Date())
    .typeError("Order date must be a valid date."),
  payments: yup
    .array()
    .of(paymentSchema)
    .min(1, "At least one payment is required.")
    .required("Payments are required."),
});

export const orderUpdateSchema = yup.object({
  newPayments: yup
    .array()
    .of(paymentSchema)
    .min(1, "At least one new payment is required.")
    .optional(),
  status: yup
    .string()
    .oneOf(
      Object.values(enums.ORDER_STATUSES),
      `Order status must be one of ${Object.values(enums.ORDER_STATUSES).join(
        ", ",
      )}.`,
    )
    .optional(),
});
